import { createApp } from 'vue'
import App from './App.vue'
// 暫時移除registerServiceWorker導入
// import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'
// 導入 i18n 實例
import i18n from './i18n'
// 導入 TText 組件
import Ttext from './components/common/TText.vue'
// 暫時移除未找到的組件和未使用的導入
// import { convertToTraditional } from './utils/textConverter'
// import TraditionalText from '@/components/common/TraditionalText.vue'

// 讀取用戶首選語言設置
const savedLanguage = localStorage.getItem('language')
if (savedLanguage) {
  i18n.global.locale.value = savedLanguage
} else {
  // 如果沒有保存的語言設置，使用默認語言（繁體中文）
  localStorage.setItem('language', 'zh-TW')
}

// 設置全局配置
axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
  ? 'https://backend:8000/api/v1'
  : '/api/v1'

// 設置超時時間
axios.defaults.timeout = 30000

// 添加請求攔截器 - 增加重試機制
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('請求配置錯誤：', error)
    return Promise.reject(error)
  }
)

// 創建應用
const app = createApp(App)

// 註冊所有圖標
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(`ElIcon${key}`, component)
}

// 註冊全局組件 
app.component('t-text', Ttext)

// 使用插件
app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(i18n) // 使用 i18n

// 全局配置
app.config.globalProperties.$axios = axios
app.config.globalProperties.$apiUrl = ''  // 不設置全局 API 路徑前綴，避免重複

// 監聽網絡狀態變化
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  // 初始化網絡狀態
  store.dispatch('shoes/updateNetworkStatus', navigator.onLine)
  
  // 監聽網絡狀態變化
  window.addEventListener('online', () => {
    console.log('網絡連接恢復')
    store.dispatch('shoes/updateNetworkStatus', true)
  })
  
  window.addEventListener('offline', () => {
    console.log('網絡連接斷開')
    store.dispatch('shoes/updateNetworkStatus', false)
  })
}

// 全局錯誤處理
app.config.errorHandler = (err, vm, info) => {
  console.error('全局錯誤:', err)
  console.error('錯誤信息:', info)
}

// 掛載應用
app.mount('#app') 